<template>
  <div v-if="opportunity !== undefined">
    <template>
      <v-card
        class="mx-auto"
        v-on:click="handleContentClick($event)"
        role="contentinfo"
      >
        <div class="opportunity desktop-container">
          <FavouritesButton
            :item="opportunity"
          />

          <v-card-title class="pt-8">
            <h1 class="display-1 headline">{{opportunity.name}}</h1>
          </v-card-title>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="pb-1">
                {{hubbdata.catagories.about}}
              </v-list-item-subtitle>
              <div v-html="opportunity.description"></div>
            </v-list-item-content>
          </v-list-item>

          <v-list two-line>
            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.company !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-briefcase</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{hubbdata.apprenticeship.labels.employer}}</v-list-item-title>
                <v-list-item-content class="pa-0">{{opportunity.company}}</v-list-item-content>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.location !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-map-marker</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.location}}</v-list-item-subtitle>
                <v-list-item-content class="pa-0">{{opportunity.location}}
                </v-list-item-content>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.industry !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-factory</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.industry}}</v-list-item-subtitle>
                <v-list-item-content class="pa-0">{{opportunity.industry}}
                </v-list-item-content>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.weekly_wage !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar-range</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.openingdate}}</v-list-item-subtitle>
                <v-list-item-title>{{opportunity.opening_date | formatDate}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.closing_date !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar-range</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.closingdate}}</v-list-item-subtitle>
                <v-list-item-title>{{opportunity.closing_date | formatDate}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.weekly_wage !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-cash-multiple</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.wage}}</v-list-item-subtitle>
                <v-list-item-title>{{opportunity.weekly_wage}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider inset></v-divider>

            <v-list-item v-if="opportunity.website_address !== null">
              <v-list-item-icon>
                <v-icon color="primary">mdi-earth</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-subtitle>{{hubbdata.apprenticeship.labels.websitelink}}</v-list-item-subtitle>
                <v-list-item-title v-if="linkSet(opportunity.website_address)"><a color="blue--text" :href="opportunity.website_address">{{opportunity.website_address}}</a></v-list-item-title>
                <v-list-item-title v-else><a color="blue--text" :href="'http://' + opportunity.website_address">{{opportunity.website_address}}</a></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>

        <WasThisUseful
          :type="'opps'"
        />
      </v-card>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful"
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';
import moment from 'moment';

export default {
  components: {
    WasThisUseful,
    FavouritesButton
  },
  computed: {
    opportunity() {
      return hubbdata.getters.getOpportunityById(this.$route.params.id)
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    linkSet(url) {
        if (url.indexOf("http") > -1){
            return true
        }
        else {
            return false
        }
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY');
      }
    }
  },
  mounted() {
    if (this.opportunity !== undefined) {
      ga('set', 'title', hubbdata.getters.getOpportunityById(this.$route.params.id).name); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
    }
  },
}
</script>

<style lang="scss" scoped>
.headline {
  word-break: normal;
  margin-right: 60px;
}

a {
  color: #0062AE;
}

.opportunity {

  .v-list-item__title,
  .v-list-item__subtitle {
    text-overflow: unset;
    white-space: unset;
  }
}
</style>